import { useEffect } from 'react'

import ROUTES from 'config/routes.json'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { showAuthConfirmDialog } from 'src/store/middlewares/authMiddleware'
import { removeSocialAuthData } from 'src/store/modules/user/actions'
import { isLoggedInSelector, socialAuthDataSelector } from 'src/store/modules/user/selectors'

const useRestoreRegConfirm = () => {
  const dispatch = useAppDispatch()
  const socialAuthData = useAppSelector(socialAuthDataSelector)
  const isLoggedIn = useAppSelector(isLoggedInSelector)

  useEffect(() => {
    const onPopStateHandler = (event: PopStateEvent) => {
      if (event.state?.url === ROUTES.HOME && socialAuthData && !isLoggedIn) {
        dispatch(showAuthConfirmDialog(socialAuthData))
        dispatch(removeSocialAuthData())
      }
    }
    window.addEventListener('popstate', onPopStateHandler)

    return () => removeEventListener('popstate', onPopStateHandler)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useRestoreRegConfirm
